<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'user-load-pallets-orders'">
  <p-card [style]="{'min-height':'200px'}">
    <ng-template pTemplate="header">
      <div class="container">
        <div class="header-container">
          <div class="title-container">
            <!-- <button (click)="goToLoadsPage()" class="btn-circle bg-yellow" style="margin-right:1em" >
              <i class="pi pi-arrow-left"></i>
            </button> -->
            <h2 class="title">{{'UserPages.PackingListView.PageTitle' | translate}}</h2>
          </div>
          <div class="searchbar-container">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input type="text"
                pInputText
                placeholder="{{'UserPages.PackingListView.SearchPallets' | translate}}"
                class="custom-input"
                [(ngModel)]="searchTerm"
                (input)="filterLoads()" />
            </span>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="body">
      <div class="subtitle-container">
        <h4 class="subtitle">
          {{'UserPages.UserLoadContainersOrders.Exporter' | translate}}
        </h4>
        <div>
          <p-button type="button" pRipple
          class="ml-2"
          pTooltip="PDF"
          (click)="downloadPackingListApi(this.importOrderDetailGuid)"
          [loading]="loadingBtnPacking"
          tooltipPosition="bottom"
          [style]="{'width':'fit-content', 'margin-left': '5px'}">
          {{ 'UserPages.PackingListView.ExportPDF' | translate }}
        </p-button>
        <p-button type="button" pRipple
          class="ml-2"
          pTooltip="Excel"
          (click)="downloadPackingListExcel(this.importOrderDetailGuid)"
          [loading]="loadingBtnPacking"
          tooltipPosition="bottom"
          [style]="{'width':'fit-content', 'margin-left': '5px'}">
          {{ 'UserPages.PackingListView.ExportExcel' | translate }}
        </p-button>
        <p-button type="button" pRipple
          class="ml-2"
          pTooltip="Excel"
          (click)="downloadProformaExcel()"
          [loading]="loadingBtnProforma"
          tooltipPosition="bottom"
          [style]="{'width':'fit-content', 'margin-left': '5px'}">
          Descargar proforma
        </p-button>
        <p-button type="button" pRipple
          class="ml-2"
          pTooltip="Excel"
          (click)="downloadIsf()"
          [loading]="loadingBtnProforma"
          tooltipPosition="bottom"
          [style]="{'width':'fit-content', 'margin-left': '5px'}">
          Descargar ISF
        </p-button>
        </div>
      </div>

      <div class="grid mb-4">
        <div *ngFor="let group of groupedDataCards" class="col-6 md:col-4 xl:col-3">
          <div class="grid grid-nogutter">
            <ng-container *ngFor="let item of group">
              <div class="col-5 flex align-items-center justify-content-center columnLeft">
                <div class="rowInfo">
                  <app-text-preview
                    classStyle="text-container-custom"
                    [text]="item.label"
                    [maxLength]="30">
                  </app-text-preview>
                </div>
              </div>
              <div class="col-7 flex align-items-center justify-content-center">
                <div class="rowInfo">
                  <app-text-preview
                    classStyle="text-container-custom"
                    [text]="item.value"
                    [maxLength]="30">
                  </app-text-preview>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="col-12 flex justify-content-start gap-1">
        <span>{{'UserPages.PackingListView.Description' | translate}}</span>
      </div>
      <form *ngIf="profilePackingListColumn && columnOptions.length > 0">
        <div class="grid col-12 px-2">
          <div *ngFor="let column of columnOptions" class="col-6 md:col-3 xl:col-2 flex align-items-center">
            <p-checkbox
              name="group"
              [value]="column.value"
              [(ngModel)]="selectedColumns"
              (onChange)="handleSelectCheck($event, column.value)"
              [inputId]="column.value"></p-checkbox>
            <label [for]="column.value" class="checkbox-label cursor-pointer">{{ column.label }}</label>
          </div>
        </div>
      </form>
      <div class="container-table">
        <div  class="section-table">
          <p-table
            #palletsList
            [value]="filteredRegisters"
            dataKey="product.pallet.id"
            [loading]="loading"
            [paginator]="true"
            [rows]="100"
            [rowsPerPageOptions]="[100, 200, 500, 1000]"
            [scrollable]="true"
            [resizableColumns]="true"
            columnResizeMode="expand"
            scrollHeight="800px"
            [tableStyle]="{ 'min-width': '50rem' }"
            [globalFilterFields]="['delivery.containerNumber', 'delivery.week', 'pallet.importOrderDetail.importOrder.importer.companyName', 'pallet.excelImportSpecies', 'pallet.excelImportVariety', 'delivery.ship']"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando desde {first} hasta {last} de {totalRecords} resultados"
            styleClass="p-datatable-gridlines">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'UserPages.PackingListView.MainTable.FolioHeader' | translate }}</th>
                <th *ngIf="!isProgram && profilePackingListColumn.packingDateColumn" >{{ 'UserPages.PackingListView.MainTable.HarvestDateHeader' | translate }}</th>
                <th *ngIf="isProgram && profilePackingListColumn.packingDateColumn" >{{ 'UserPages.PackingListView.MainTable.PackingDateHeader' | translate }}</th>
                <th>{{ 'UserPages.PackingListView.MainTable.SpecieHeader' | translate }}</th>
                <th>{{ 'UserPages.PackingListView.MainTable.VarietyHeader' | translate }}</th>
                <th *ngIf="profilePackingListColumn.producerColumn">{{ 'UserPages.PackingListView.MainTable.GrowerHeader' | translate }}</th>
                <th *ngIf="profilePackingListColumn.csgColumn">CSG</th>
                <th *ngIf="profilePackingListColumn.cspColumn">CSP</th>
                <th *ngIf="profilePackingListColumn.bagTypeColumn">{{ 'UserPages.PackingListView.MainTable.CaseTypeHeader' | translate }}</th>
                <th *ngIf="profilePackingListColumn.packagingColumn">{{ 'UserPages.PackingListView.MainTable.PackagingHeader' | translate }}</th>
                <th *ngIf="profilePackingListColumn.netWeightColumn">{{ 'UserPages.PackingListView.MainTable.NetWeightHeader' | translate }}</th>
                <th *ngIf="profilePackingListColumn.fridgeStorageColumn">{{ 'UserPages.PackingListView.MainTable.FridgeStorageHeader' | translate }}</th>
                <th *ngIf="profilePackingListColumn.boxSizeColumn">{{ 'UserPages.PackingListView.MainTable.PackageHeader' | translate }}</th>
                <th>{{ 'UserPages.PackingListView.MainTable.CasesHeader' | translate }}</th>
                <th>{{ 'UserPages.PackingListView.MainTable.SizeHeader' | translate }}</th>
                <th  *ngIf="profilePackingListColumn.labelColumn">{{ 'UserPages.PackingListView.MainTable.LabelHeader' | translate }}</th>
                <!-- <th>{{ 'UserPages.PackingListView.MainTable.ContainerHeader' | translate }}</th> -->
                <th *ngIf="profilePackingListColumn.gradeColumn">{{ 'UserPages.PackingListView.MainTable.GradeHeader' | translate }}</th>
                <th *ngIf="profilePackingListColumn.categoryColumn">{{ 'UserPages.PackingListView.MainTable.CategoryHeader' | translate }}</th>
                <th *ngIf="profilePackingListColumn.temptaleColumn">{{ 'UserPages.PackingListView.MainTable.TemptaleHeader' | translate }}</th>
                <th *ngIf="profilePackingListColumn.cooColumn">{{ 'UserPages.PackingListView.MainTable.cooHeader' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr>
                <td>{{ product.palletNumber }}</td>
                <td *ngIf="profilePackingListColumn.packingDateColumn">{{ product.excelImportHarvestDate |  date: 'dd-MM-yyyy'}}</td>
                <td>{{ product.excelImportSpecies }}</td>
                <td>{{ product.excelImportVariety }}</td>
                <td *ngIf="profilePackingListColumn.producerColumn">{{ product.producer }}</td>
                <td *ngIf="profilePackingListColumn.csgColumn">{{ product.csg }}</td>
                <td *ngIf="profilePackingListColumn.cspColumn">{{ product.csp }}</td>
                <td *ngIf="profilePackingListColumn.bagTypeColumn">{{product.excelImportBagType }}</td>
                <td *ngIf="profilePackingListColumn.packagingColumn">{{ product.excelImportPackaging }}</td>
                <td *ngIf="profilePackingListColumn.netWeightColumn">{{ product.excelImportNetWeight }}</td>
                <td *ngIf="profilePackingListColumn.fridgeStorageColumn">{{ product.fridgeStorageName }}</td>
                <td *ngIf="profilePackingListColumn.boxSizeColumn">{{ product.excelImportBoxSize }}</td>
                <td>{{ product.excelImportBoxesPerPallet }}</td>
                <td>{{ product.speciesSize }}</td>
                <td *ngIf="profilePackingListColumn.labelColumn">{{ product.excelImportTag }}</td>
                <!-- <td>{{ product.excelImportContainerNumber }}</td> -->
                <td *ngIf="profilePackingListColumn.gradeColumn">{{ product.excelImportGrade }}</td>
                <td *ngIf="profilePackingListColumn.categoryColumn">{{ product.category }}</td>
                <td *ngIf="profilePackingListColumn.temptaleColumn">{{ product.excelImportTemptale }}</td>
                <td *ngIf="profilePackingListColumn.cooColumn">{{ product.excelImportOriginCountry }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="summary-container">
        <h3 class="summary-title">Specie Summary:</h3>

        <div class="section-toogles">
          <div class="container-toogle">
            <p-inputSwitch [(ngModel)]="withPackaging" (onChange)="updateProfilePackingList()" />
            <h4 class="label-toogle">
              {{ 'UserPages.PackingListView.SummaryTable.PackagingSwitch' | translate }}
            </h4>
          </div>
          <div class="container-toogle">
            <p-inputSwitch [(ngModel)]="withLabel" (onChange)="updateProfilePackingList()" />
            <h4 class="label-toogle">
              {{ 'UserPages.PackingListView.SummaryTable.LabelSwitch' | translate }}
            </h4>
          </div>
          <div class="container-toogle">
            <p-inputSwitch [(ngModel)]="withSpeciesSize" (onChange)="updateProfilePackingList()" />
            <h4 class="label-toogle">
              {{ 'UserPages.PackingListView.SummaryTable.SizeSwitch' | translate }}
            </h4>
          </div>
        </div>

        <div class="summary-table">
          <p-table
          #palletsSummaryTable
          [value]="palletsSummary"
          [loading]="loadingSummary"
          [scrollable]="true"
          [resizableColumns]="true"
          columnResizeMode="expand"
          scrollHeight="800px"
          [tableStyle]="{ 'width': 'fit-content' }"
          styleClass="p-datatable-gridlines">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'UserPages.PackingListView.MiniTables.Vessel' | translate }}</th>
              <th>{{ 'UserPages.PackingListView.MainTable.SpecieHeader' | translate }}</th>
              <th>{{ 'UserPages.PackingListView.SummaryTable.VarietyHeader' | translate }}</th>
              <th *ngIf="withPackaging">{{ 'UserPages.PackingListView.MainTable.PackagingHeader' | translate }}</th>
              <th *ngIf="withLabel">{{ 'UserPages.PackingListView.MainTable.LabelHeader' | translate }}</th>
              <th *ngIf="withSpeciesSize">{{ 'UserPages.PackingListView.MainTable.SizeHeader' | translate }}</th>
              <th>{{ 'UserPages.PackingListView.SummaryTable.BoxesHeader' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product>
            <tr>
              <td>{{importOrderDetailArray?.ship}}</td>
              <td>{{ product.speciesName }}</td>
              <td>{{ product.varietyName }}</td>
              <td *ngIf="withPackaging">{{ product.packaging }}</td>
              <td *ngIf="withLabel">{{ product.label }}</td>
              <td *ngIf="withSpeciesSize">{{ product.speciesSize }}</td>
              <td>{{ product.boxesPerPallets }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer" >
            <tr>
              <td></td>
              <td></td>
              <td *ngIf="withPackaging"></td>
              <td *ngIf="withLabel"></td>
              <td *ngIf="withSpeciesSize"></td>
              <td>Total:</td>
              <td>{{ totalBoxesPerPallets }}</td>
            </tr>
          </ng-template>
        </p-table>
        </div>
      </div>
    </ng-template>
  </p-card>
</app-user-dashboard>



